import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataProvider } from "../../providers/data/data";
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-entry',
  templateUrl: 'entry.html',
})
export class EntryPage {
  private lookups: {
    "Users": {
      "Id": string;
      "AccountId": string;
      "FirstName": string;
      "LastName": string;
      "Email": string;
      "CreatedDate": string;
      "UpdatedDate": any;
      "Password": string;
      "IsActive": boolean;
    }[];
    "Categorys": {
      "Id": string;
      "AccountId": string;
      "Name": string;
      "Description": string;
      "CreatedDate": string;
      "IsActive": boolean;
      "UpdatedDate": any;
      "Index": number;
      "Goal": number;
      "Icon": string;
    }[];
    "Locations": {
      "Id": string;
      "AccountId": string;
      "Name": string;
      "Description": any;
      "CreatedDate": string;
      "IsActive": boolean;
    }[];
  };

  private when = {
    month: new Date().getFullYear() + "-" + new Date().getMonth() + 1 + "-" + new Date().getDate()
  };

  private Categorys = [];
  private Users = [];
  private Locations = [];

  private cat: string;
  private loc: string;
  private usr: string;
  private amt: number;
  private des: string;
  private tax: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider) {
    this.when.month = new Date().toISOString();
    this.getLookups();
  }

  postEntry() {
    let ntry = {
      "CategoryId": this.cat,
      "LocationId": this.loc,
      "AppliesToId": this.usr,
      "When": this.when.month,
      "Description": this.des,
      "Amount": this.amt,
      "Taxable": this.tax,
      "AccountId": sessionStorage.getItem("__aid__")
    };

    this.dataProvider.entryPost(ntry).
      then(this.getResponse).
      then(res => {
        this.loadHomePage();
      }).
      catch();
  };

  getLookups() {
    this.dataProvider.lookupsGet().
      then(this.getResponse).
      then(res => {
        this.lookups = res;

        this.Categorys = this.lookups.Categorys;
        this.Users = this.lookups.Users;
        this.Locations = this.lookups.Locations;
        this.setDefaults();
      });
  };

  getResponse(res) {
    return res.json();
  };

  loadHomePage() {
    this.navCtrl.push(HomePage);
  };

  setDefaults() {
    let uid = sessionStorage.getItem("__uid__");

    for (let user of this.Users) {
      if (user.Id == uid) {
        user.selected = true;
        break;
      }
    }

    if (this.navParams.data.item != undefined) {
      for (let category of this.Categorys) {
        if (category.Id == this.navParams.data.item.Id) {
          category.selected = true;
          category.disabled = true;
          break;
        }
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/pages/entry/entry.ts